<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/voidreasons/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/voidreasons/searches"
  [AllowEdit]="true" EditUrl="enforcement/voidreasons/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>

